// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fab[data-v-853854f2] {\n    position: fixed;\n    cursor: pointer;\n    right: 5vw;\n    bottom: 4vh;\n    z-index: 999;\n    background-color: #00B7C6;\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    box-shadow: 0 10px 10px rgb(0 0 0 / 20%), 0 4px 4px rgb(0 0 0 / 15%)\n}\n.fab-icon[data-v-853854f2] {\n    color: white;\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 0; top: 0; right: 0; bottom: 0;\n    margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
